import React, {Component} from 'react';
import {observer} from "mobx-react/index";
import {Link} from "react-router-dom";
import Price from "./Price";
import Change from "./Change";

@observer
class SearchResults extends Component {

    constructor(props) {
        super(props);
        this.getSearchResults = this.getSearchResults.bind(this);
        this.clearSearch = this.clearSearch.bind(this);

    }

    getSearchResults(results) {
        let appState = this.props.appState;
        let currency = appState.currency;
        let currencyPrefix = currency.prefix;
        let currencySuffix = currency.suffix;
        let currencyValue = appState.currency.value || 1.0;
        const cursor = appState.searchCursor;

        if (results && results.coins && results.coins.length > 0) {
            let coins = results.coins;
            return coins.map((coin, i) => {
                let routingLink = "/coin/" + coin.symbol;

                let rank = coin.rank || '';
                if (rank) {
                    rank = '#' + rank;
                }

                if (cursor === i) {
                    appState.searchSelectedCoin = coin;
                }

                return (
                <div key={coin.symbol} className={`cg-search-result${cursor === i ? ' active' : ''}`}>
                    <Link to={routingLink} onClick={this.clearSearch} >
                        <div>

                            <span className={'cg-name'}>{rank} {coin.name}</span>

                            <span className={'cg-label'}>{coin.symbol}</span>
                            <span className={'cg-price'}>
                                {currencyPrefix}{Price.format(coin.price * currencyValue)}{currencySuffix}
                            </span>
                            <span className={'cg-percentage'}>
                                &nbsp;<Change change={coin.change}/>
                            </span>
                        </div>
                        <div className={'search-result-symbol'}>

                        </div>
                    </Link>
                </div>);
            });
        }

        return null;
    }

    clearSearch() {
        this.props.appState.searchQuery = "";
        this.props.appState.searchResults = {};
        this.props.appState.searchCursor = 0;
    }

    render() {
        let results = this.props.appState.searchResults;
        let resultMarkup = this.getSearchResults(results);
        if (!resultMarkup) {
            return null;
        }

        return (
            <div className="cg-search-results">
                {resultMarkup}
            </div>
        );
    }
}

export default SearchResults;



// WEBPACK FOOTER //
// ./src/SearchResults.js